import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { Link } from 'react-router-dom';
import { ArsenalArmyView } from '@Selectors/arsenal/make/view/ArsenalArmyView';
import MultiColorProgressBar from '@Builder/myArsenal/army/utils/multi-color.progress-bar';
import { Col } from 'reactstrap';
import bt_new_paint_list from '@Images/en/bt_new_paint_list.png';

interface IArsenalArmyComponentProps {
  army: ArsenalArmyView;
}

const ArsenalArmyComponent: React.FC<ArsenalArmyComponentProps> = ({ army }) => {
  return (
    <Col xs={6} md={3} xl={2} className="army_list_row text-center">
      <Link to={`/${document.documentElement.lang}/arsenal/armies/${army.id}`}>
        <picture className="img-fluid w-100">
          {army.logo &&
            (<source srcSet={`${process.env.CDN ?? ''}${army.logo}`} />)}
          <img src={`${process.env.CDN ?? ''}${bt_new_paint_list}`} alt={army.name} />
        </picture>
        <MultiColorProgressBar readings={army.readings} showLegends={false} showValues={false} />
        <h4 className="boxtitre">{(army.name || '').substring(0, 60)}</h4>
      </Link>
    </Col>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArsenalArmyComponentProps) => ({
  army: owsProps.army
});

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArsenalArmyComponent);

type ArsenalArmyComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>